export enum CopyAccountSetting {
  Settings,
  Integrations,
  Events
}
